export class DragDropReader {
    // Convert File[] to FileList
    static filesArrayToFileList(files: File[]): FileList {
        const dataTransfer = new DataTransfer();
        files.forEach(file => dataTransfer.items.add(file));
        return dataTransfer.files;
    }

    // Recursively read all entries in a directory
    static async readAllEntries(dirReader: FileSystemDirectoryReader): Promise<FileSystemEntry[]> {
        const entries: FileSystemEntry[] = [];
        return new Promise<FileSystemEntry[]>((resolve) => {
            const readBatch = () => {
                dirReader.readEntries(async (batch: FileSystemEntry[]) => {
                    if (batch.length === 0) {
                        resolve(entries);
                    } else {
                        entries.push(...batch);
                        readBatch();
                    }
                });
            };
            readBatch();
        });
    }

    // Recursively traverse file tree
    static async traverseFileTree(entry: FileSystemEntry): Promise<File[]> {
        return new Promise<File[]>((resolve) => {
            if (entry.isFile) {
                (entry as FileSystemFileEntry).file((file: File) => resolve([file]));
            }
            else if (entry.isDirectory) {
                const dirReader = (entry as FileSystemDirectoryEntry).createReader();
                DragDropReader.readAllEntries(dirReader).then(async (allEntries) => {
                    const files = await Promise.all(
                        allEntries.map((ent) => DragDropReader.traverseFileTree(ent))
                    );
                    resolve(files.flat());
                });
            }
            else {
                resolve([]);
            }
        });
    }
}
